import {
    Dialog, DialogTitle, DialogContent, DialogActions, IconButton,
    useTheme, useMediaQuery,
    type SxProps, type Theme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface GenericDialogProps {
    open: boolean;
    title: string;
    onClose: () => void;
    children: React.ReactNode;
    actions?: React.ReactNode;
    maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | false;
    fullWidth?: boolean;
    fullScreen?: boolean;
    sx?: SxProps<Theme>;
}

const GenericDialog: React.FC<GenericDialogProps> = ({
    open,
    title,
    onClose,
    children,
    actions,
    maxWidth = "sm",
    fullWidth = true,
    fullScreen,
    sx,
}) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const resolvedFullScreen = fullScreen !== undefined ? fullScreen : isSmallScreen;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={maxWidth}
            fullWidth={fullWidth}
            fullScreen={resolvedFullScreen}
            sx={sx}
        >
            <DialogTitle
                sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
            >
                {title}
                <IconButton
                    onClick={onClose}
                    size="small"
                    sx={{ "&:focus": { outline: "none", boxShadow: "none" } }}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>{children}</DialogContent>
            {actions ? <DialogActions>{actions}</DialogActions> : null}
        </Dialog>
    );
};

export default GenericDialog;
